import React from 'react';
import { string, oneOf } from 'prop-types';
import cx from 'classnames';

const propTypes = {
  /** Html element. */
  tag: string,
  /** Variant of the grid, normal = 12cols, fibonacci = 26cols */
  variant: oneOf(['normal', 'fibonacci']),
};

const CLASS_ROOT = 'grid';

const Grid = ({ className, tag = 'div', variant = 'fibonacci', ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${variant}`]: variant !== 'normal',
    },
    className
  );
  const TagName = tag;

  return <TagName className={classes} {...other} />;
};

Grid.displayName = 'Grid';
Grid.propTypes = propTypes;

export default Grid;



// WEBPACK FOOTER //
// ./src/components/Grid/Grid.js